function isSVGElement(element) {
  return element instanceof SVGElement && element.tagName !== "svg";
}
export {
  isSVGElement
};
//# sourceMappingURL=is-svg-element.js.map
